export default __webpack_public_path__ + "static/media/checkbox_tik.118a8d83.svg";